(() => {
  const root = document.querySelector('#MainContent[data-template="index"]');
  if (!root || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const animations = new Set();
  let observer;
  const stop = () => {
    observer?.disconnect();
    animations.forEach((animation) => animation.cancel());
    animations.clear();
  };
  const start = () => {
    stop();
    if (preference.matches || window.Shopify?.designMode) return;
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        const animation = entry.target.animate(
          [{ opacity: .75, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }],
          { duration: 480, easing: 'cubic-bezier(.22,1,.36,1)' }
        );
        animations.add(animation);
        animation.finished.then(() => animations.delete(animation)).catch(() => animations.delete(animation));
      });
    }, { threshold: .12 });
    root.querySelectorAll('.section-resource-list__header, .shopify-section:not(:first-child) .hero__content-wrapper').forEach((element) => observer.observe(element));
  };
  start();
  preference.addEventListener('change', start);
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', (event) => { if (event.persisted) start(); });
})();
